<template>
  <el-dialog title="坏码列表"
             append-to-body=""
             :visible.sync="visible"
             width="520px"
             @closed="handleClosed"
             :close-on-press-escape="false">
    <!-- <div style="text-align: right;margin-bottom: 10px">

    </div> -->
    <el-table border
              v-loading="loading"
              :data="list">
      <el-table-column label="标签序号">
        <template slot-scope="{row}">
          {{row.beginTagNo | tagCount() }} - {{row.endTagNo | tagCount() }}
        </template>
      </el-table-column>
      <el-table-column label="坏码数量"
                       prop="tagCount">
      </el-table-column>
      <el-table-column label="操作"
                       width="70">
        <template slot-scope="{row}">
          <el-button type="text"
                     @click="deleteBadTag(row)">移除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination background
                   @current-change="handleCurrentChange"
                   :current-page.sync="config.pageNum"
                   :page-size="config.pageSize"
                   layout="total, prev, pager, next"
                   :total="total">
    </el-pagination>
    <span slot="footer">
      <el-button @click="toggleModal(false)"
                 :loading="loading">关闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'bad-tag-modal',
  props: {
    callback: Function
  },
  data () {
    return {
      loading: false,
      visible: false,
      config: {
        pageNum: 1,
        pageSize: 10,
        tagSegDetailsId: null
      },
      list: [],
      total: 0
    }
  },
  methods: {
    toggleModal (visible) {
      this.visible = visible
    },
    handleClosed () {
      this.config.pageNum = 1
      this.config.tagSegDetailsId = null
      this.total = 0
      this.list = []
      this.callback && this.callback()
    },
    handleCurrentChange (current) {
      this.config.pageNum = current
      this.fetchList()
    },
    deleteBadTag (row) {
      this.$confirm('此操作将复原该坏码段, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        this.$store.dispatch('label/deletebadtag', {
          payload: {
            // tagSegDetailsId: this.config.tagSegDetailsId,
            badTagSegId: row.badTagSegId
          },
          success: (res) => {
            this.loading = false
            this.fetchList()
          },
          fail: () => {
            this.loading = false
          }
        })
      })
      // this.$prompt('请输入标签序号', '提示', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   inputPattern: /[0-9]+/,
      //   inputErrorMessage: '请输入标签序号'
      // }).then(({ value }) => {
      //   this.loading = true
      //   this.$store.dispatch('label/deletebadtagbytagnoseg', {
      //     payload: {
      //       tagSegDetailsId: this.config.tagSegDetailsId,
      //       beginTagNo: value,
      //       endTagNo: value
      //     },
      //     success: (res) => {
      //       this.loading = false
      //       this.fetchList()
      //     },
      //     fail: () => {
      //       this.loading = false
      //     }
      //   })
      // })
    },
    fetchList (cb) {
      this.loading = true
      this.$store.dispatch('label/getbadtags', {
        payload: {
          ...this.config
        },
        success: (res) => {
          this.loading = false
          this.total = res.data.total
          this.list = res.data.records
          cb && cb()
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    fetch (options) {
      this.config = {
        ...this.config,
        ...options
      }
      this.fetchList(() => {
        this.toggleModal(true)
      })
    }
  },
  created () { },
  mounted () { }
}
</script>
<style lang="stylus" scoped></style>
